import React from 'react';
import cn from 'classnames';
import { LoadingScreen, SuccessfulScreen } from 'components/Atoms';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Icon, { SirenErrorIcon, UploadingIcon } from 'components/Atoms/Icon';
import { isMobile } from './common';
import { t } from './lang';
import { withIntlProvider } from './intlContext';

const { confirm, error, info } = Modal;

export const showModalError = ({
  title,
  content,
  icon,
  okText,
  okType,
  onOk,
  onCancel,
  centered = true,
}) => {
  const regex = /\r?\n/g;
  const formattedData = content?.replace(/\r?\n/g, '<br >');
  error({
    title: (
      <div>
        <div>
          <Icon component={icon || SirenErrorIcon} />
        </div>
        <div className="text-lg mt-15">{t(title) || title || 'Error!'}</div>
      </div>
    ),
    icon: null,
    content: (
      <div className="mt-20">
        {regex.test(content) ? (
          <div dangerouslySetInnerHTML={{ __html: formattedData }}></div>
        ) : (
          t(content) || content || ''
        )}
      </div>
    ),
    okText: t(okText) || 'OK',
    okType: okType || 'primary',
    className: cn('my-error-modal'),
    okButtonProps: {
      className: 'site-button btn-primary-custom h-45',
      style: {
        width: '120px',
      },
    },
    centered,
    onOk(close) {
      onOk && onOk();
      close();
    },
    onCancel() {
      onCancel && onCancel();
    },
  });
};

export const showModalConfirm = ({
  title = '',
  content = '',
  icon,
  okText = 'Yes',
  okType = 'primary',
  cancelText = 'No',
  onOk = () => Promise.resolve(),
  onCancel = () => Promise.resolve(),
  loading,
  centered = false,
  ...rest
}) => {
  confirm({
    title: t(title) || title,
    icon: icon || <ExclamationCircleOutlined />,
    content: t(content) || content,
    okText: t(okText) || okText,
    okType: okType,
    cancelText: t(cancelText) || cancelText,
    onOk,
    onCancel,
    centered,
    closable: true,
    ...rest,
  });
};

export const showModalConfirmStylePrimary = (props) => {
  showModalConfirm({
    ...props,
    icon: null,
    className: cn('my-modal-confirm-primary-style', props.className),
    okButtonProps: props.okButtonProps || {
      className: `site-button btn-primary-custom ${isMobile ? 'h-40' : 'h-45'}`,
      style: {
        width: isMobile ? '100px' : '175px',
      },
    },
    cancelButtonProps: props.cancelButtonProps || {
      className: `site-button btn-secondary-outline ${
        isMobile ? 'h-40' : 'h-45'
      }`,
      style: {
        width: isMobile ? '100px' : '175px',
      },
    },
    centered: typeof props.centered !== 'undefined' ? props.centered : true,
  });
};

export const showModalSuccessfulScreen = (props) => {
  // Wrap SuccessfulScreen with IntlProvider to avoid React Intl context errors
  const SuccessfulScreenWithIntl = withIntlProvider(SuccessfulScreen);
  
  const modal = info({
    icon: null,
    className: 'my-modal-successful-screen',
    wrapClassName: 'my-modal-successful-screen',
    centered: true,
    content: (
      <SuccessfulScreenWithIntl
        {...props}
        onClickButtonPrimary={() => {
          props.onClickButtonPrimary && props.onClickButtonPrimary();
          modal.destroy();
        }}
      />
    ),
    okButtonProps: { style: { display: 'none' } },
  });
  return modal;
};

export const showUploadingModal = ({ content }) => {
  const modal = info({
    icon: null,
    className: 'upload-modal-wrapper',
    wrapClassName: 'upload-modal-wrapper',
    centered: true,
    content: (
      <div className="t-center">
        <UploadingIcon />
        <div className="upload-text mt-30">{t(content) || content}</div>
      </div>
    ),
    okButtonProps: { style: { display: 'none' } },
  });

  return modal;
};

export const showLoadingCheckoutModal = () => {
  // Wrap LoadingScreen with IntlProvider to avoid React Intl context errors
  const LoadingScreenWithIntl = withIntlProvider(LoadingScreen);
  
  const modal = info({
    icon: null,
    className: 'loading-modal-checkout',
    wrapClassName: 'loading-modal-checkout',
    centered: true,
    content: (
      <div>
        <LoadingScreenWithIntl />
      </div>
    ),
    okButtonProps: { style: { display: 'none' } },
  });
  return modal;
};
